<template>
  <footer class="app-footer" :class="{ 'app-footer--spaced': marginTop }">
    <div class="app-footer__inner">
      <div v-if="partnerLogo" class="app-footer__partner">
        <img
          class="app-footer__partner-logo"
          :src="partnerLogo"
          alt="Partner logo"
          id="logoPartner"
        />
      </div>

      <div
        v-if="partnerLogo && !disablePoweredBy"
        class="app-footer__divider"
        aria-hidden="true"
      ></div>

      <div class="app-footer__brand" v-if="!disablePoweredBy">
        <span class="app-footer__text">{{ $t("powered-by") }}</span>
        <a
          class="app-footer__link"
          :href="rocketfuelUrl"
          target="_blank"
          rel="noopener noreferrer"
          id="logo"
        >
          <img
            class="app-footer__rocketfuel-logo"
            :src="require('@/assets/img/logo.svg')"
            :alt="poweredBy"
          />
        </a>
        <b-tooltip target="logo" triggers="hover" placement="top" class="tip">
          {{ poweredBy }}
        </b-tooltip>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    marginTop: Boolean,
  },
  computed: {
    ...mapGetters({
      marketInfo: "user/marketInfo",
    }),
    poweredBy() {
      if (
        this.marketInfo &&
        this.marketInfo.whiteLabel &&
        this.marketInfo.whiteLabel.colorSchema &&
        this.marketInfo.whiteLabel.colorSchema.partnerLabel
      ) {
        return this.marketInfo.whiteLabel.colorSchema.partnerLabel;
      }
      return "Rocketfuel";
    },
    rocketfuelUrl() {
      return "https://rocketfuelblockchain.com/";
    },
    partnerLogo() {
      if (
        this.marketInfo &&
        this.marketInfo.whiteLabel &&
        this.marketInfo.whiteLabel.colorSchema &&
        this.marketInfo.whiteLabel.colorSchema.logo
      ) {
        return this.marketInfo.whiteLabel.colorSchema.logo;
      }
      return "";
    },
    disablePoweredBy() {
      if (
        this.marketInfo &&
        this.marketInfo.whiteLabel &&
        this.marketInfo.whiteLabel.colorSchema
      ) {
        return this.marketInfo.whiteLabel.colorSchema.disablePoweredBy;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.app-footer {
  $text-muted: #6e728b;
  $border: rgba(27, 31, 59, 0.08);
  $surface-muted: #f4f6fb;

  width: 100%;
  margin-top: auto;
  padding: 10px 16px;
  border-top: 1px solid $border;
  background: $surface-muted;
  border-radius: 0 0 8px 8px;

  &--spaced {
    margin-top: 20px;
  }

  &__inner {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    flex-wrap: wrap;
    min-height: 28px;
  }

  &__partner {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 4px 8px;
    border-radius: 8px;
    background: #fff;
    border: 1px solid $border;
  }

  &__partner-logo {
    display: block;
    max-width: 88px;
    max-height: 22px;
    width: auto;
    height: auto;
    object-fit: contain;
  }

  &__divider {
    width: 1px;
    height: 18px;
    background: rgba(27, 31, 59, 0.12);
    flex-shrink: 0;
  }

  &__brand {
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }

  &__text {
    font-size: 12px;
    font-weight: 500;
    line-height: 1.2;
    color: $text-muted;
    white-space: nowrap;
  }

  &__link {
    display: inline-flex;
    align-items: center;
    line-height: 0;
    border-radius: 6px;
    transition: opacity 0.2s ease;

    &:hover {
      opacity: 0.85;
      text-decoration: none;
    }
  }

  &__rocketfuel-logo {
    display: block;
    width: 22px;
    height: 22px;
    object-fit: contain;
  }
}
</style>
